import React from 'react';
import { render } from 'react-dom';

import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
// import Hello from './Hello';
import './style.css';
import App from './App';


const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#ff8f33',
      main: '#f06a00',
      dark: '#b35000',
      contrastText: '#fff',
    },
    secondary: {
      light: '#009eb3',
      main: '#006674',
      dark: '#002d33',
      contrastText: '#fff',
    },
    type: 'light',
  },
  typography: {
    fontFamily: '"Raleway", sans-serif',
    // fontWeightMedium: 100,
    useNextVariants: true,
  },
  overrides: {
    MuiTypography: {
      gutterBottom: {
        marginBottom: 20,
      },
    },
  },
});


render(<MuiThemeProvider theme={theme}><App /></MuiThemeProvider>, document.getElementById('root'));
